import { onMounted, Ref, ref } from 'vue';

export const screenInnerHeight = ref('100vh');
export function useWindowInnerHeight(): Ref<string> {
  onMounted(() => {
    screenInnerHeight.value = window.innerHeight + 'px';
  });
  return screenInnerHeight;
}
